// Add new enum here for additional icons
export var BulletListType;
(function (BulletListType) {
    BulletListType["STANDARD"] = "standard";
    BulletListType["ORDERED"] = "ordered";
    BulletListType["TICK"] = "tick";
    BulletListType["CROSS"] = "cross";
})(BulletListType || (BulletListType = {}));
// Add new enum here for additional icon colours
export var BulletIconColors;
(function (BulletIconColors) {
    BulletIconColors["GREEN"] = "green";
    BulletIconColors["RED"] = "red";
    BulletIconColors["WHITE"] = "white";
    BulletIconColors["COPY"] = "copy";
    BulletIconColors["TITLE"] = "title";
})(BulletIconColors || (BulletIconColors = {}));
